import { Item } from 'apprise-ui/dnd/model'
import { NativeTypes } from 'react-dnd-html5-backend'
import { Droppable, DroppableProps } from '../dnd/droppable'

export type FileDroppabeProps = Omit<DroppableProps<File[]>, 'types'> & Partial<{

    onDrop: (files: File[]) => void

}>


export const FileDroppable = (props: FileDroppabeProps) => {

    const { onDrop, children, ...rest } = props

    return <Droppable<Item & { files: File[] }> accept={[NativeTypes.FILE]} path='none' onDrop={({ files }) => onDrop?.(files)} {...rest} >
        {props.children}
    </Droppable>

}